import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { TpaSrcQueryParamProviderSymbol } from '@wix/thunderbolt-symbols'
import { ExternalIdTpaSrcQueryParamProviderDs } from './tpaSrcQueryParamProvidersDs'
import { bindSharedFeatureParts } from '../featureLoader'
import { PinnedExternalIdStore } from './pinnedExternalIdStore'
import { PinnedExternalIdStoreSymbol, TpaSrcUtilitySymbol } from '../symbols'
import { TpaSrcUtility } from './tpaSrcUtility'
import { TpaCommonsSideEffects } from './tpaCommonsSideEffects'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'

export const editor: ContainerModuleLoader = (bind) => {
	bindSharedFeatureParts(bind)
	bind(TpaSrcQueryParamProviderSymbol).to(ExternalIdTpaSrcQueryParamProviderDs)
	bind(PinnedExternalIdStoreSymbol).to(PinnedExternalIdStore)
	bind(TpaSrcUtilitySymbol).to(TpaSrcUtility)
	bind(ModelUpdatesHandlersImplementor).to(TpaCommonsSideEffects)
}
